import React, { Component } from 'react';
import { omit } from 'lodash';
import { connect } from 'react-redux';

import Loading from '../../components/loading';

import {
  getCurrentUserMembership,
  getCurrentPurchase,
  getConsumerFieldValues,
  getPurchaseConsumerFieldSchemas,
} from '../../selectors/purchase-selector';
import Purchase from '../../lib/purchase';

export class RedirectPurchase extends Component {
  componentWillMount() {
    this.redirectTo = this.redirectTo();
    if (this.redirectTo) window.location = this.redirectTo;
  }

  isClaimPage() {
    return /claim\/?$/.exec(this.props.match.url);
  }

  isCommitPage() {
    return /commit\/?$/.exec(this.props.match.url);
  }

  isPurchaseFieldsPage() {
    return /purchase-fields\/?$/.exec(this.props.match.url);
  }

  redirectTo() {
    const { purchase } = this.props;
    const purchaseClaimed = !Purchase.isCreated(purchase.status);
    const isClaimPage = this.isClaimPage();

    if (!isClaimPage && !purchaseClaimed) return `/purchases/${purchase.slug}/claim`;
    if (isClaimPage && purchaseClaimed) return `/purchases/${purchase.slug}`;

    if (this.isCommitPage() && Purchase.isCompleted(purchase)) {
      return `/purchases/${purchase.slug}`;
    }

    return false;
  }

  render() {
    if (this.redirectTo) return <Loading />;

    const ComposedComponent = this.props.composedComponent;
    return <ComposedComponent {...omit(this.props, 'composedComponent')} />;
  }
}

export default function (ComposedComponent) {
  const mapStateToProps = (state) => {
    const purchase = getCurrentPurchase(state);
    const currentUserMembership = getCurrentUserMembership(state);
    const consumerFieldValues = getConsumerFieldValues(state);
    const consumerFieldSchemas = getPurchaseConsumerFieldSchemas(state);

    return {
      purchase,
      currentUserMembership,
      consumerFieldValues,
      consumerFieldSchemas,
      composedComponent: ComposedComponent,
    };
  };

  return connect(mapStateToProps)(RedirectPurchase);
}



// WEBPACK FOOTER //
// ./src/components/hoc/redirect-purchase.js